// Vigência do seguro renovado: começa no fim da vigência atual (ou hoje, se já venceu) e dura 1 ano
export const periodoRenovacao = (vigenciaFinal?: string | Date): [Date, Date] => {
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  const fim = vigenciaFinal ? new Date(`${String(vigenciaFinal).slice(0, 10)}T00:00:00`) : hoje;
  const inicio = fim > hoje ? fim : hoje;
  const umAno = new Date(inicio);
  umAno.setFullYear(inicio.getFullYear() + 1);
  return [inicio, umAno];
}
